<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('rating_create.title') }}</h1>
      <rating-form :colony="colony" :apiary="apiary"></rating-form>
    </b-container>
  </div>
</template>

<script>
import RatingForm from '../components/RatingForm'
export default {
  name: 'RatingCreate',
  props: ['apiary', 'colony'],
  components: { RatingForm }
}
</script>

<style scoped>

</style>
